import React from 'react';
import { WrenchScrewdriverIcon } from '../../../automationStudioIcons';
import styles from '../../../../../styles/automationStudio/automationStudio.module.scss';
import { LABELS } from '../../../content';
import CollapsibleSection from './CollapsibleSection';

export default function ParametersSection({
    isExpanded,
    onToggle,
    height,
    onResizeStart,
    badge = 0,
}) {
    return (
        <CollapsibleSection
            icon={WrenchScrewdriverIcon}
            title={LABELS.SECTION_PARAMETERS}
            badge={badge}
            isExpanded={isExpanded}
            onToggle={onToggle}
            height={height}
            onResizeStart={onResizeStart}
            expandAriaLabel="Expand parameters"
            collapseAriaLabel="Collapse parameters"
        >
            <div className={styles.emptyState}>
                <p className={`${styles.asTypoBody2} ${styles.asTextSecondary}`}>
                    {LABELS.NO_PARAMETERS_DEFINED}
                </p>
            </div>
        </CollapsibleSection>
    );
}
